import { render } from "./Manco.vue?vue&type=template&id=61eaea53"
import script from "./Manco.vue?vue&type=script&lang=js"
export * from "./Manco.vue?vue&type=script&lang=js"

import "./Manco.vue?vue&type=style&index=0&id=61eaea53&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__